import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'ridango-terms-modal-content',
    templateUrl: './terms-modal-content.component.html',
})
export class TermsModalContentComponent {
    @Input() termsUrl = '';
    @Output() onAgree = new EventEmitter<any>(false);


    agreeTerms(agree: boolean) {
        this.onAgree.emit(agree);
    }
}
